import { useState } from "react";
import { HiChevronDown } from "react-icons/hi2";
import faqHeroBg from "../assets/faqhero.png";

const faqs = [
  {
    question: "What exactly is Altus Online School?",
    answer:
      "Altus Online School is a fully recognized, new-age digital school offering comprehensive education. We bring the complete schooling experience directly to your home. Unlike basic tuition classes or recorded video apps, Altus functions like a physical school, with live interactive daily classes, expert teachers, regular exams, parent-teacher meetings, and extra-curricular clubs, but with the flexibility to learn from anywhere and choose between recognized Indian or international boards.",
  },
  {
    question:
      "Is the Altus Online School certificate valid for college admissions?",
    answer:
      "Yes, absolutely. Depending on your chosen path, students receive mark sheets from recognized boards like NIOS (valid for Indian and global universities, JEE, NEET, and UPSC) or Cambridge/NWAC (valid for universities in the US, UK, Canada, and globally).",
  },
  {
    question: "How are exams conducted in an online school?",
    answer:
      "Internal assessments and unit tests are conducted online through our secure portal. For final board exams (such as NIOS, Cambridge, and NWAC), students appear at a designated board-approved exam center near their physical home location.",
  },
  {
    question: "What if my child misses a live class?",
    answer:
      "We understand that life happens. Teachers can schedule extra support where needed. Every live class is recorded in HD and uploaded to our 24/7 Learning Management System (LMS), so students can watch missed lessons, download notes, and submit assignments anytime.",
  },
  {
    question: "Can my child transfer back to a traditional physical school later?",
    answer:
      "Yes. Because our curricula align with national (NCERT) and international standards, students receive a valid transfer certificate and mark sheet, making it seamless to move back to a regular physical school if needed.",
  },
  {
    question: "Is too much screen time harmful for my child?",
    answer:
      "We take screen fatigue seriously. Our class schedule is designed to reduce fatigue, and we follow WHO and government screen-time guidance. Live classes are interactive, mandatory eye-rest breaks are built in, and many assignments (like reading and drawing) are completed offline.",
  },
  {
    question: "What are the benefits of choosing Altus Online School?",
    answer:
      "At Altus, we believe learning is a journey, not a competition. Students benefit from personalized learning, a diverse global peer community, expert guidance, flexible schedules, and engaging technology that supports meaningful progress.",
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleItem = (index) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${faqHeroBg})` }}
        aria-labelledby="faq-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="faq-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            FAQ
          </h1>
        </div>
      </section>

      <section
        className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
        aria-labelledby="faq-heading"
      >
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent"
          aria-hidden
        />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
              Common questions
            </p>
            <h2
              id="faq-heading"
              className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:mt-5 sm:text-4xl"
            >
              Frequently Asked Questions
            </h2>
            <p className="mt-4 text-pretty text-base leading-relaxed text-ink/70 sm:mt-5 sm:text-lg">
              Know more about us.
            </p>
          </div>

          <div className="mx-auto mt-10 max-w-4xl space-y-3">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              const panelId = `faq-panel-${index}`;
              const buttonId = `faq-button-${index}`;

              return (
                <article
                  key={item.question}
                  className="overflow-hidden rounded-2xl border border-brand/12 bg-white ring-1 ring-brand/5"
                >
                  <h3>
                    <button
                      id={buttonId}
                      type="button"
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-base font-semibold text-brand transition hover:bg-brand-light/45 sm:px-6 sm:py-5 sm:text-lg"
                      aria-expanded={isOpen}
                      aria-controls={panelId}
                      onClick={() => toggleItem(index)}
                    >
                      <span>{item.question}</span>
                      <HiChevronDown
                        className={`h-5 w-5 shrink-0 text-brand/80 transition-transform duration-200 ${
                          isOpen ? "rotate-180" : ""
                        }`}
                        aria-hidden
                      />
                    </button>
                  </h3>
                  {isOpen ? (
                    <div
                      id={panelId}
                      role="region"
                      aria-labelledby={buttonId}
                      className="border-t border-brand/10 px-5 py-4 sm:px-6 sm:py-5"
                    >
                      <p className="text-sm leading-relaxed text-ink/75 sm:text-base">
                        {item.answer}
                      </p>
                    </div>
                  ) : null}
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}

export default FAQ;
